import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ToasterService } from 'angular2-toaster';
import { AuthService } from './auth.service';
import { ModalAiSettingsComponent } from '../shared/modals/modal-ai-settings/modal-ai-settings.component';

@Injectable()
export class AiSettingsDialogService {
  constructor(
    private dialog: MatDialog,
    private auth: AuthService,
    private toasterService: ToasterService
  ) {}

  open(): MatDialogRef<ModalAiSettingsComponent> | null {
    if (this.auth.getRole() !== 'admin') {
      this.toasterService.popAsync(
        'warning',
        'Access denied',
        'Only administrators can edit the AI snapshot prompt.'
      );
      return null;
    }

    return this.dialog.open(ModalAiSettingsComponent, {
      width: '920px',
      maxWidth: '95vw',
      maxHeight: 'calc(100vh - 76px)',
      position: { top: '68px' },
      panelClass: 'ai-settings-dialog',
      autoFocus: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ai-settings-dialog.service.ts